export const StudiesCategory: string = 'Studies';
export const StudiesClickedAction: string = 'Studies button: Clicked';
